import React, { useEffect, useState } from 'react';
import { Star, X } from 'lucide-react';

const SEEN_KEY = 'mibeko_rate_prompt_done';
const OPENS_KEY = 'mibeko_app_opens';
const MIN_OPENS = 4;
const PLAY_URL = 'https://play.google.com/store/apps/details?id=cd.mibeko.app';

/**
 * Pop-up invitant l'utilisateur a noter l'application sur le Play Store.
 * S'affiche apres quelques ouvertures de l'app (compteur local), une seule
 * fois. "Plus tard" reporte, "Noter" / "Non merci" marquent comme traite.
 */
const RateAppModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(SEEN_KEY)) return;
      const opens = parseInt(localStorage.getItem(OPENS_KEY) || '0', 10) + 1;
      localStorage.setItem(OPENS_KEY, String(opens));
      if (opens >= MIN_OPENS) {
        const t = setTimeout(() => setShow(true), 1800);
        return () => clearTimeout(t);
      }
    } catch {}
  }, []);

  const dismiss = (remember) => {
    if (remember) {
      try { localStorage.setItem(SEEN_KEY, '1'); } catch {}
    }
    setShow(false);
  };

  const rate = () => {
    try { localStorage.setItem(SEEN_KEY, '1'); } catch {}
    try { window.open(PLAY_URL, '_blank', 'noopener'); } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="rate-overlay" role="dialog" aria-modal="true" data-testid="rate-app-modal">
      <div className="rate-card">
        <button
          className="rate-close"
          onClick={() => dismiss(false)}
          aria-label="Fermer"
          data-testid="rate-later-btn"
        >
          <X size={18} />
        </button>

        <div className="rate-stars" aria-hidden="true">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star key={i} size={26} fill="#F5B301" color="#F5B301" />
          ))}
        </div>

        <h3 className="rate-title" data-testid="rate-title">Vous aimez Mibeko ?</h3>
        <p className="rate-text">
          Votre note aide d'autres Congolais a decouvrir leurs droits.
          Prenez quelques secondes pour nous soutenir sur le Play Store.
        </p>

        <button className="rate-primary" onClick={rate} data-testid="rate-now-btn">
          Noter 5 etoiles
        </button>
        <button className="rate-secondary" onClick={() => dismiss(true)} data-testid="rate-no-btn">
          Non merci
        </button>
      </div>
    </div>
  );
};

export default RateAppModal;
